import type { Ref } from 'vue';

import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IMassReviewPaymentSystemPayload } from '../types';
import {
  ADMIN_PAYMENT_SYSTEM_DETAILS_LIST_QUERY_KEY,
  ADMIN_PAYMENT_SYSTEM_DETAILS_MASS_REVIEW_API_URL,
  ADMIN_PAYMENT_SYSTEM_DETAILS_MASS_REVIEW_MUTATION_KEY,
  PAYMENT_SYSTEM_DETAILS_PERMISSIONS,
} from '../constants';

export default function useMassReviewPaymentSystemMutation(
  rejectionReason: Ref<string | undefined>,
): IContextMutationResult<void, Error, IMassReviewPaymentSystemPayload> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IMassReviewPaymentSystemPayload>({
    mutationKey: [ADMIN_PAYMENT_SYSTEM_DETAILS_MASS_REVIEW_MUTATION_KEY],
    mutationFn: ({ actionType, ...payload }) => fetchPost<void>(
      ADMIN_PAYMENT_SYSTEM_DETAILS_MASS_REVIEW_API_URL,
      { ...payload, rejection_reason: rejectionReason.value },
      {
        permission: PAYMENT_SYSTEM_DETAILS_PERMISSIONS.UPDATE,
        urlParams: {
          actionType,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [ADMIN_PAYMENT_SYSTEM_DETAILS_LIST_QUERY_KEY] });
      displayPresetToast('edited');
    },
  });
}
